import { use } from 'react';
import { useTranslation } from 'react-i18next';
import CheckRounded from '@mui/icons-material/CheckRounded';
import Close from '@mui/icons-material/Close';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import TenantsProviderContext from 'features/tenants/providers/tenants-provider/contexts/tenants-provider-context';
import styles from './tenant-details-header.module.scss';

const TenantDetailsHeader = (): React.JSX.Element => {
  const { t } = useTranslation('tenants');
  const { viewingMode, setViewingMode, closeDetails, cancelEditDetails, isUpdatingTenant } = use(TenantsProviderContext);
  const { hasPermission } = usePermissionAuthorization();

  const renderEditingButtons = (): React.JSX.Element => (
    <>
      <Button data-testid="tenantDetailCancelButton" variant="text" onClick={() => cancelEditDetails()} disabled={isUpdatingTenant}>
        {t('tenantDetails.cancelFormButton')}
      </Button>
      <Button
        data-testid="tenantDetailSubmitButton"
        startIcon={<CheckRounded />}
        variant="contained"
        type="submit"
        disabled={isUpdatingTenant}
      >
        {t('tenantDetails.saveFormButton')}
      </Button>
    </>
  );

  const renderViewingButtons = (): React.JSX.Element | null =>
    hasPermission(Permission.UpdateTenant) ? (
      <Button
        data-testid="tenantDetailEditButton"
        startIcon={<ModeEditOutlineOutlinedIcon className="icon-on-text" />}
        variant="text"
        onClick={() => setViewingMode('editing')}
        disabled={isUpdatingTenant}
      >
        {t('tenantDetails.editFormButton')}
      </Button>
    ) : null;

  return (
    <div className={styles.tenantDetailsHeaderContainer}>
      {viewingMode === 'editing' ? renderEditingButtons() : renderViewingButtons()}

      <IconButton aria-label="close" className={styles.closeButton} onClick={() => closeDetails()} data-testid="tenantPopupCloseButton">
        <Close />
      </IconButton>
    </div>
  );
};

export default TenantDetailsHeader;
